<template>
  <aha-modal
    @hide="hideModal"
    :title="titleYouAreNotLeadingThisPresentation"
  >
    <p class="mb-2">
      {{ $i18nPresenter.t('You can change this setting now:') }}
    </p>
    <div class="bg-secondary-10 px-3 py-2.5">
      <p class="mb-2 font-bold">
        {{ $i18nPresenter.t('Who takes the lead?') }}
      </p>
      <aha-radio
        class="mb-2.5"
        name="whoTakesTheLead"
        :value="false"
        v-model="$store.state.presentation.audiencePacing"
        @change="onChangeAudiencePacing"
      >
        {{ $i18nPresenter.t('Presenter') }}
        <aha-icon
          class="ml-1 text-base-70"
          name="question"
          viewBox="0 0 24 24"
          width="15"
          height="15"
          v-tooltip="presenterPacingTooltip"
        />
      </aha-radio>

      <aha-radio
        name="whoTakesTheLead"
        :value="true"
        v-model="$store.state.presentation.audiencePacing"
        @change="onChangeAudiencePacing"
      >
        {{ $i18nPresenter.t('Audience (self-paced)') }}
        <aha-icon
          class="ml-1 text-base-70"
          name="question"
          viewBox="0 0 24 24"
          width="15"
          height="15"
          v-tooltip="$i18nPresenter.t('Participants start from the first slide and proceed on their own. Great for surveys')"
        />
      </aha-radio>
    </div>
    <template #action>
      <aha-antd-button
        v-aha-emit-action
        name="cancelAudiencePacing"
        variant="text"
        class="font-bold"
        @click="hideModal"
      >
        <span>{{ $i18nPresenter.t('Cancel') }}</span>
      </aha-antd-button>
      <aha-antd-button
        v-aha-emit-action
        name="presentAudiencePacing"
        variant="primary"
        class="ml-2"
        @click="$emit('present')"
      >
        <span>{{ $i18nPresenter.t('Present Now') }}</span>
      </aha-antd-button>
    </template>
  </aha-modal>
</template>

<script>

import { mapActions, mapState } from 'vuex'
import Util from '@/util'
import Config from '@/config'
import Socket from '@/socket'
import eventCategories from '@/constant/eventCategories'

export default {
  data() {
    return {
      titleYouAreNotLeadingThisPresentation: this.$i18nPresenter.t('You’re not leading this presentation'),
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
      presentation: (state) => state.presentation,
    }),
    presenterPacingTooltip() {
      return this.$i18nPresenter.t('The audience follow you. They can\'t proceed to the next slide on their own.')
    },
  },
  methods: {
    ...mapActions(['setSyncLoadingAction']),
    onChangeAudiencePacing() {
      const payload = {
        socketId: Socket.getSocketId(),
        audiencePacing: this.presentation.audiencePacing,
      }
      this.setSyncLoadingAction(1)
      this.updatePresentation(payload)
      let name = 'presenter'
      if (this.$store.state.presentation.audiencePacing) {
        name = 'audience'
      }
      Util.mixpanelTracking(eventCategories.PRESENTATION_EDITOR, 'Settings menu > Who takes the lead', name)
    },
    updatePresentation(payload) {
      this.$http
        .put(Config.api.updatePresentation + this.$route.params.id, payload)
        .then(
          () => {
            this.setSyncLoadingAction(2)
          },
          () => {
            this.setSyncLoadingAction(3)
          },
        )
    },
    hideModal() {
      this.$emit('hide')
    },
  },
}
</script>
